import React from 'react'

const PageTitle = ({ title }) => {
  return (
    <div className="flex flex-col items-start px-0 pb-[1.5rem] sm:pb-[2rem] lg:pb-[2.5rem] box-border max-w-full">
      <h1 className="m-0 text-[1.375rem] sm:text-[1.625rem] lg:text-[2em] font-semibold break-words">
        {title}
      </h1>
    </div>
  )
}

export default PageTitle
